import axios from 'axios';
import {modal} from '../../modal-template/modal-template';

const DATA_ATTR = 'data-troika-applications';
const CLASS_PREFIX = 'troika-applications';


export function initTroikaApplications($container) {
    const $templateMain = document.querySelector(`[${DATA_ATTR}-template-main]`);
    const $templateEmpty = document.querySelector(`[${DATA_ATTR}-template-empty]`);
    const $templateCard = document.querySelector(`[${DATA_ATTR}-template-card]`);
    const $templateList = document.querySelector(`[${DATA_ATTR}-template-list]`);
    const $templateProfile = document.querySelector(`[${DATA_ATTR}-template-profile]`);

    let $componentContainer = null;
    let $groupCount = null
    let $contentContainer = null
    let $loader = null

    let currentSkip = 0;
    let currentTake = 50;
    let totalCount = 0;

    init();

    const troikaData = [
        {
            name: 'Тройка 1',
            roles: [{name: 'Интервизор', is_find: true, is_you: false}, {
                name: 'Психолог',
                is_find: false,
                is_you: false
            }, {name: 'Клиент', is_find: true, is_you: true}]
        },
        {
            name: 'Тройка 2',
            roles: [{name: 'Интервизор', is_find: true, is_you: true}, {
                name: 'Психолог',
                is_find: false,
                is_you: false
            }, {name: 'Клиент', is_find: false, is_you: false}]
        },
        {
            name: 'Тройка 3',
            roles: [{name: 'Интервизор', is_find: true, is_you: false}, {
                name: 'Психолог',
                is_find: true,
                is_you: true
            }, {name: 'Клиент', is_find: true, is_you: false}]
        },
    ];

    async function init() {
        console.log('$templateMain', $templateMain)
        if (!$templateMain) return;
        await renderMain();
        fetchGroups();
    }

    function fetchGroups() {
        // renderEmpty()
        $loader.style.display = 'none';
        renderList(troikaData, 3);
        return


        $loader.style.display = 'flex';
        axios.get('/api/groups', {
            params: {skip: currentSkip, take: currentTake}
        })
            .then(function (response) {
                const {data, meta} = response.data;
                if (!data || !data.length) {
                    renderEmpty();
                    $loader.style.display = 'none';
                    return;
                }

                const total = (meta && typeof meta.total !== 'undefined') ? meta.total : data.length;
                totalCount = total;
                renderList(data, total);
                $loader.style.display = 'none';
                //currentSkip += currentTake;
            })
            .catch(function (error) {
                console.error(error);
                renderEmpty();
            });
    }

    function renderMain() {
        const $mainFragment = $templateMain.content.cloneNode(true);

        $componentContainer = $mainFragment.querySelector(`[${DATA_ATTR}]`);
        $groupCount = $componentContainer.querySelector(`[${DATA_ATTR}-group-count]`);
        $contentContainer = $componentContainer.querySelector(`[${DATA_ATTR}-content]`);
        $loader = $componentContainer.querySelector(`[${DATA_ATTR}-loader]`);

        $container.appendChild($mainFragment);
        document.dispatchEvent(new CustomEvent('troika-live:render-complete', {bubbles: true}));
    }

    function renderEmpty() {
        if ($groupCount) $groupCount.textContent = '';
        $contentContainer.innerHTML = '';
        const emptyFragment = $templateEmpty.content.cloneNode(true);
        $contentContainer.appendChild(emptyFragment);
    }

    function renderList(groups, count) {
        $contentContainer.innerHTML = '';
        if ($groupCount) $groupCount.textContent = String(count);

        const $listFragment = $templateList.content.cloneNode(true);
        const $listContainer = $listFragment.querySelector(`[${DATA_ATTR}-list]`);

        groups.forEach(group => {
            renderCard($listContainer, group);
        });


        $contentContainer.appendChild($listFragment);
    }

    function renderCard($cardList, group) {
        const cardFragment = $templateCard.content.cloneNode(true);

        const $rolesContainer = cardFragment.querySelector(`[${DATA_ATTR}-roles]`);

        // Разделяем роли на найденные и ненайденные
        const foundRoles = (group.roles || []).filter(r => !!r.is_find);
        const notFoundRoles = (group.roles || []).filter(r => !r.is_find);

        // Сначала рендерим найденные роли
        foundRoles.forEach(role => {
            renderRole($rolesContainer, role);
        });

        // Если есть ненайденные роли, вставляем пустой блок, затем их
        if (notFoundRoles.length) {
            const $empty = document.createElement('div');
            $empty.className = `${CLASS_PREFIX}__profile--empty`;

            const $emptyDot = document.createElement('div');
            $emptyDot.className = `${CLASS_PREFIX}__profile-dot`;
            $empty.appendChild($emptyDot);

            $rolesContainer.appendChild($empty);

            notFoundRoles.forEach(role => {
                renderRole($rolesContainer, role);
            });
        }

        $cardList.appendChild(cardFragment);
    }

    function renderRole($roleList, role) {
        const $roleFragment = $templateProfile.content.cloneNode(true);
        const $roleCard = $roleFragment.querySelector(`[${DATA_ATTR}-card]`);
        const $roleName = $roleFragment.querySelector(`[${DATA_ATTR}-name]`);
        const $roleImage = $roleFragment.querySelector(`.${CLASS_PREFIX}__profile-image`);

        // Имя — добавляем "(Вы)", если нужно
        $roleName.textContent = role.name + (role.is_you ? ' (Вы)' : '');

        // Если роль помечена как найденная — добавляем модификаторы
        if (role.is_find) {
            // активный профиль (показывает чек)
            $roleCard.classList.add(`${CLASS_PREFIX}__profile--active`);

            // модификатор цвета для image по имени роли
            const name = (role.name || '').trim();
            if (name === 'Клиент') {
                $roleImage.classList.add(`${CLASS_PREFIX}__profile-image--blue`);
            } else if (name === 'Интервизор') {
                $roleImage.classList.add(`${CLASS_PREFIX}__profile-image--pirple`);
            } else if (name === 'Психолог') {
                $roleImage.classList.add(`${CLASS_PREFIX}__profile-image--green`);
            }
        }

        $roleList.appendChild($roleFragment);
    }

}
